import Api from '../api';
import * as firebase from "firebase/app";
import 'firebase/messaging';

// We have to interface with a legacy (cordova) component, so loosen
// up the type checking on the global object. (declare a reference to it as type 'any')
const g:any = global;

export default class FirebaseCloudMessagingBrowser {

  static instance : FirebaseCloudMessagingBrowser;
  messaging : firebase.messaging.Messaging;

  /// Umm....
  private token : string = '';
  private associationDesired : boolean = false;

  static getInstance() { return this.instance ? this.instance : this.instance = new this(); }

  private constructor() {
    // Your web app's Firebase configuration
    var firebaseConfig = {
        apiKey: "AIzaSyCynWAyk8XvGQmZF91Kk3DASZYFN8zYoQA",
        authDomain: "mobile-rinble.firebaseapp.com",
        databaseURL: "https://mobile-rinble.firebaseio.com",
        projectId: "mobile-rinble",
        storageBucket: "mobile-rinble.appspot.com",
        messagingSenderId: "1062307271032",
        appId: "1:1062307271032:web:0d58d0ac6672ef15bdf88d"
    };
    
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    this.messaging = firebase.messaging();
    this.messaging.usePublicVapidKey("BDHMVQusRvmFCvrmqCE1lX8ebuXQve9fnWIyiduCDY53Y2GNqOrsysYJRX-OfN03j1fKgoNHHbiybVGj5tj76Zs");

    this.messaging.requestPermission().then(() => {
      console.log('Notification permission granted.');
      this.messaging.getToken().then((token) => {
        // console.log(token);
        this.setToken(token);
        // console.log('Token acquired');
      })
    }).catch((err) => {
      console.log('Permission not granted for notifications.', err);
    });
  }
  setToken(token : string) {
    // console.log("STEP ONE: TOKEN IS ACQUIRED", {token});
    this.token=token;
    if (this.associationDesired) this.associateToken();
  }
  associateToken() {
    // Associate the token with the currently logged in user.
    this.associationDesired = true;
    if (this.token==='') return;
    console.log({msg: 'ASSOC FIREBASE TOKEN', token: this.token});
    let api = new Api(g.gqlClient());
    api.addFirebaseToken(this.token);  
  }

  disassociateToken() {
    console.log({msg: 'DISASSOC FIREBASE TOKEN'});
    // Disassociate the token from the currently logged in user.
    this.associationDesired = false;
    if (this.token==='') return;
    let api = new Api(g.gqlClient());
    api.delFirebaseToken(this.token);

    // Clear any waiting notifications
    if (g.FCMPlugin !== undefined) g.FCMPlugin.clearAllNotifications();
  }

  // Notifications are recieved while the app is running, or when a user
  // clicks their notification tray.
  onNotification(notification : any) {
    /* eslint no-console: off */
    console.log({notification});
  }
}